import { usePlaybackState } from '@app/core/playback/hooks/usePlayback';
import { useVideoPlaybackState } from '@app/core/playback/video/useVideoPlaybackState';
import {
  VideoJsPlayer,
  VideoJsPlayerProps,
} from '@app/modules/logger/screens/stream/modes/video/video-js/VideoJsPlayer';
import { useEffect } from 'react';
import Player from 'video.js/dist/types/player';

/**
 * Video player component that connects with the PlaybackProvider.
 * Reads the src from the store and registers the player when ready.
 */
export const PlaybackVideoJsPlayer = ({
  onReady: onReadyProp,
  ...rest
}: Omit<VideoJsPlayerProps, 'src'>) => {
  const setVideoJsPlayer = useVideoPlaybackState((s) => s.setVideoJsPlayer);
  const src = usePlaybackState((s) => s.mediaSrc);

  const onReady = (player: Player) => {
    setVideoJsPlayer(player);
    onReadyProp?.(player);
  };

  useEffect(() => {
    return () => {
      setVideoJsPlayer(null);
    };
  }, [setVideoJsPlayer]);

  if (!src) {
    return null;
  }

  return <VideoJsPlayer src={src!} onReady={onReady} {...rest} />;
};
